import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { calculateToolUsagePercentage } from '../../utils/analyticsUtils';
import './ToolUsageChart.css';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ToolUsageChart = ({ selectedSpace = 'personal', selectedPeriod = '7 derniers jours', onSpaceChange }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    buildChartData();
  }, [selectedSpace, selectedPeriod]);

  const buildChartData = () => {
    const toolUsage = calculateToolUsagePercentage(selectedSpace, selectedPeriod);

    const labels = toolUsage.map(item => item.tool === '[object Object]' ? 'Unknown Tool' : item.tool);
    const data = toolUsage.map(item => parseFloat(item.percentage));

    setChartData({
      labels,
      datasets: [
        {
          label: 'Tool Usage (%)',
          data,
          backgroundColor: '#4CAF50',
          borderColor: '#388E3C',
          borderWidth: 1,
        },
      ],
    });
  };

  return (
    <div className="tool-usage-chart">
      <h3 className="chart-title">Top fonctionnalités utilisées</h3>

      <div className="filter-container">
        <label htmlFor="space-filter" className="filter-label">Espace :</label>
        <select
          id="space-filter"
          className="filter-dropdown"
          value={selectedSpace}
          onChange={(e) => onSpaceChange(e.target.value)}
        >
          <option value="personal">Espace Personnel</option>
          <option value="project">Espace Projet</option>
          <option value="manager">Espace Manager</option>
        </select>
      </div>

      {chartData && (
        <Bar
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  label: (context) => `${context.raw}%`,
                },
              },
              title: {
                display: true,
                text: 'Pourcentage d\'utilisation des outils',
              },
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: 'Outils',
                  color: '#388E3C',
                  font: {
                    size: 14,
                    weight: 'bold',
                  },
                },
                ticks: { color: '#4CAF50' },
              },
              y: {
                title: {
                  display: true,
                  text: 'Pourcentage (%)',
                  color: '#388E3C',
                  font: {
                    size: 14,
                    weight: 'bold',
                  },
                },
                ticks: { color: '#4CAF50' },
                beginAtZero: true,
              },
            },
          }}
        />
      )}
    </div>
  );
};

export default ToolUsageChart;